import { Button, Spinner } from '@vmware-react/clarity';
import React, { FC } from 'react';
import './DecoratedElements.css';
import cn from 'classnames';
import { l10n } from '../with-app-root/i18n/i18nUtil';

export const CenteredDiv: FC<{}> = props => (
  <div className="centered-div">{props.children}</div>
);

export const CenterAlignedDiv: FC<{}> = props => (
  <div className="center-aligned-div">{props.children}</div>
);

export const CenterAlignedSpinner: FC<{
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  inline?: boolean;
}> = props => (
  <div className="center-aligned-spinner">
    <SpinnerWithText {...props} />
  </div>
);

export const SpinnerWithText: FC<{
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  inline?: boolean;
}> = props => {
  return (
    <span className="spinner-with-text">
      <Spinner size={props.size || 'sm'} inline={props.inline} />
      <span className="spinner-text">{props.text || props.children}</span>
    </span>
  );
};

export const Bolder: FC<{}> = props => (
  <div
    style={{
      fontWeight: 'bolder'
    }}
  >
    {props.children}
  </div>
);

export const Bullets: FC<{ times?: number }> = ({ times }) => (
  <span>
    {Array(times || 5)
      .fill(1)
      .map((v, i) => (
        <React.Fragment key={i}>&bull;</React.Fragment>
      ))}
  </span>
);

export const TruncatedText: FC<{
  width: number | string;
  children?: string;
  title?: string;
  align?: 'start' | 'center' | 'end';
}> = props => (
  <span
    className="truncated-text"
    style={{
      width: props.width,
      textAlign: props.align
    }}
    title={props.title || props.children}
  >
    {props.children}
  </span>
);

export const IconNeutral = () => (
  <clr-icon shape="circle" class="is-solid icon-neutral" />
);

export const IconSuccess: FC<{ size?: number }> = props => (
  <clr-icon
    shape="success-standard"
    size={props.size || 18}
    class="is-solid is-success text-icon"
    title={l10n('success')}
  />
);

export const IconError: FC<{ size?: number }> = props => (
  <clr-icon
    shape="error-standard"
    size={props.size || 18}
    class="is-solid is-error text-icon"
    title={l10n('error')}
  />
);

export const Placeholder: React.FunctionComponent = () => (
  <div className="placeholder-image" />
);

export const DatagridButton: React.FC<{
  title: string;
  iconShape: string;
  disabled?: boolean;
  onClick?: () => void;
}> = props => (
  <div className="datagrid-button" title={props.title}>
    <Button
      family="link"
      icon={true}
      attrs={{ 'aria-label': props.title }}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <clr-icon shape={props.iconShape} />
    </Button>
  </div>
);

export const DatagridTextButton: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  text: string;
  disabled?: boolean;
  onClick?: () => void;
}> = props => (
  <div
    className={cn('datagrid-text-button', props.className)}
    style={props.style}
    title={props.text}
  >
    <Button
      family="link"
      attrs={{ 'aria-label': props.text }}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.text}
    </Button>
  </div>
);
